/*
 * HomePage Messages
 *
 * This contains all the text for the HomePage component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'cwt.translations.HomePage.Title',
    defaultMessage: 'Budget your own kitchen worktop that fits your style.',
  },
  priceEstimation: {
    id: 'cwt.translations.HomePage.PriceEstimation',
    defaultMessage: 'Choose from different worktop and sink materials, sizes and styles to create a custom made worktop that\'s perfect for you. The custom made worktop calculator makes it easy to try out different options and compare their prices.',
  },
  createNew: {
    id: 'cwt.translations.HomePage.CreateNew',
    defaultMessage: 'Create new',
  },
  restoreSaved: {
    id: 'cwt.translations.HomePage.RestoreSaved',
    defaultMessage: 'Open Existing',
  },
  loadFailed: {
    id: 'cwt.translations.HomePage.LoadFailed',
    defaultMessage: 'We could not find your code. Please check if you entered the worktop code correctly.',
  },
  planSavedTitle: {
    id: 'cwt.translations.HomePage.PlanSaved.Title',
    defaultMessage: 'Here’s your worktop code',
  },
  planSavedDesc: {
    id: 'cwt.translations.HomePage.PlanSaved.Description',
    defaultMessage: 'Your worktop is saved to this unique code. Bring it with you when contacting a co-worker at IKEA.',
  },
  copyLink: {
    id: 'cwt.translations.HomePage.PlanSaved.CopyLink',
    defaultMessage: 'Copy link',
  },
  linkCopied: {
    id: 'cwt.translations.HomePage.PlanSaved.LinkCopied',
    defaultMessage: 'Link copied!',
  },
  sendEmail: {
    id: 'cwt.translations.HomePage.PlanSaved.SendEmail',
    defaultMessage: 'Send code to email address',
  },
  emailSubject: {
    id: 'cwt.share.Email.Subject',
    defaultMessage: 'IKEA custom made worktop',
  },
  emailBody: {
    id: 'cwt.share.Email.Body',
    defaultMessage: 'Check out my IKEA custom made worktop:\n\n{{url}}\n\n',
  },
  calculatorTitle: {
    id: 'cwt.translations.HomePage.CustomWorktopCalculator',
    defaultMessage: 'Custom Worktop Calculator',
  },
  planCompare: {
    id: 'cwt.translations.HomePage.Compare',
    defaultMessage: 'Compare',
  },
  print: {
    id: 'cwt.translations.HomePage.Print',
    defaultMessage: 'Print summary',
    description: 'Will trigger printing',
  },
});
